import React, { useState } from 'react';
import { 
  User, 
  Palette,
  Shield,
  ChevronRight,
  Settings
} from 'lucide-react';
import { PersonalSettings } from './sections/PersonalSettings';
import { AppearanceSettings } from './sections/AppearanceSettings';
import { UserPermissionsSettings } from './sections/UserPermissionsSettings';
import { FeatureSettings } from './sections/FeatureSettings';
import { useUserRole } from '../../hooks/useUserRole';

const SECTIONS = [
  {
    id: 'personal',
    label: 'Persönliche Einstellungen',
    icon: User,
    component: PersonalSettings
  },
  {
    id: 'appearance',
    label: 'Darstellung',
    icon: Palette,
    component: AppearanceSettings
  },
  {
    id: 'permissions',
    label: 'Benutzerrechte',
    icon: Shield,
    component: UserPermissionsSettings,
    managerOnly: true
  },
  {
    id: 'features',
    label: 'Funktionen',
    icon: Settings,
    component: FeatureSettings,
    managerOnly: true
  }
];

export const SettingsLayout = () => {
  const [activeSection, setActiveSection] = useState(SECTIONS[0].id);
  const [isMobileExpanded, setIsMobileExpanded] = useState(false);
  const { isManager } = useUserRole();
  
  // Filter sections based on user role
  const availableSections = SECTIONS.filter(section => 
    !section.managerOnly || (section.managerOnly && isManager)
  );

  // Ensure active section is available
  const ActiveComponent = availableSections.find(section => section.id === activeSection)?.component;

  return (
    <div className="space-y-6">
      <div className="sm:flex sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Einstellungen</h2>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden">
        <div className="md:grid md:grid-cols-12 md:divide-x md:divide-gray-200 dark:md:divide-gray-700">
          {/* Sidebar */}
          <div className="md:col-span-3 md:block">
            <nav className="flex flex-col">
              {availableSections.map((section) => {
                const isActive = section.id === activeSection;
                return (
                  <button
                    key={section.id}
                    onClick={() => {
                      setActiveSection(section.id);
                      setIsMobileExpanded(false);
                    }}
                    className={`
                      flex items-center px-4 py-3 text-sm font-medium
                      ${isActive 
                        ? 'bg-indigo-50 dark:bg-indigo-900/50 border-l-4 border-indigo-600 dark:border-indigo-400 text-indigo-600 dark:text-indigo-400' 
                        : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50'
                      }
                    `}
                  >
                    <section.icon className="h-5 w-5 mr-3" />
                    <span className="flex-1 text-left">{section.label}</span>
                    <ChevronRight className={`
                      h-5 w-5 md:hidden
                      ${isActive ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-400 dark:text-gray-500'}
                    `} />
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Content */}
          <div className="md:col-span-9">
            <div className="p-6">
              {ActiveComponent && <ActiveComponent />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};